export default "/images/close-line.png?b5ceb1b4ae124714d71681e444698838";